<template>
    <div class="border-b border-[#eeeff2] py-3">
        <span class="block text-[20px] font-[CircularBook] text-center">Open Orders</span>
    </div>
    <div
        class="flex items-center h-[calc(100%-64px)]"
        v-if="orderBookLoading"
    >
        <Loading />
    </div>
    <div class="relative overflow-x-auto" v-if="!orderBookLoading">
        <table class="bg-white w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 price-table whitespace-nowrap">
            <thead>
            <tr class="text-[#2a395a] text-[12px] font-[CircularBook] tracking-wider border-b border-[#eeeff2]">
                <th scope="col" class="ps-5 pe-2 py-2.5">
                    Total
                </th>
                <th scope="col" class="px-2 py-2.5 text-right">
                    Amount
                </th>
                <th scope="col" class="ps-2 pe-5 py-2.5 text-right">
                    Price
                </th>
            </tr>
            </thead>
            <tbody class="text-[12px] font-[CircularBook]">
            <tr v-for="sellNone in (22 - Object.keys(orderBook.SELL).length)" class="pointer-event-none">
                <td class="ps-5 pe-2 py-[0] text-[#2a395a]">-</td>
                <td class="px-2 py-[0] text-right text-[#2a395a]">-</td>
                <td class="ps-2 pe-5 py-[0] text-right text-[#cf3d3d]">-</td>
            </tr>
            <tr v-for="(sell, index) in orderBook.SELL" :key="index" @click="setInputTerminal(sell)">
                <td class="ps-5 pe-2 py-[0] text-[#2a395a]">{{ sell.total }}</td>
                <td class="px-2 py-[0] text-right text-[#2a395a]">{{ sell.amount }}</td>
                <td class="ps-2 pe-5 py-[0] text-right text-[#cf3d3d]">{{ sell.price }}</td>
            </tr>
            </tbody>
            <tbody>
                <tr
                    class="border-t border-b border-[#366fed] font-[CircularBook] text-[14px] bg-[#e0e8fa] pointer content-center items-center justify-center text-[#2a395a] h-[29px]"
                    @click="setInputTerminal(currentPrice.toFixed(market.price_decimals))"
                >
                    <td colspan="3" class="text-center p-0">{{ currentPrice.toFixed(market.price_decimals) }}</td>
                </tr>
            </tbody>
            <tbody class="text-[12px] font-[CircularBook]">
                <tr v-for="(buy, index) in orderBook.BUY" :key="index" @click="setInputTerminal(buy)">
                    <td class="ps-5 pe-2 py-[0] text-[#2a395a]">{{ buy.total }}</td>
                    <td class="px-2 py-[0] text-right text-[#2a395a]">{{ buy.amount }}</td>
                    <td class="ps-2 pe-5 py-[0] text-right text-[#58bd7d]">{{ buy.price }}</td>
                </tr>
                <tr v-for="buyNone in (22 - Object.keys(orderBook.BUY).length)" class="pointer-event-none">
                    <td class="ps-5 pe-2 py-[0] text-[#2a395a]">-</td>
                    <td class="px-2 py-[0] text-right text-[#2a395a]">-</td>
                    <td class="ps-2 pe-5 py-[0] text-right text-[#58bd7d]">-</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script setup>
import {onMounted, ref} from "vue";
import axios from "axios";
import {backendSocket} from "../../sockets";
import {globalStore} from "../../stores";
import Loading from "../Loading.vue";

const market = pageData.market
const marketData = pageData.market.market_data
const orderBook = ref({BUY: [], SELL: []})
const orderBookLoading = ref(true);
const currentPrice = ref(parseFloat(marketData.last_price));

onMounted(() => {
    backendSocket.channel(`exchange.public.${market.id}`)
        .listen('.order.book.updated', (data) => {
            orderBook.value = data.orderBook
        })
        .listen('.public_trade.created', ({trade}) => {
            currentPrice.value = parseFloat(trade.price);
        })

    axios.post("/exchange/query/order-book", {marketId: market.id}).then(({ data: { data } }) => {
        orderBook.value = data
        orderBookLoading.value = false
    }).catch(({ response: {data} }) => {
        console.log(data)
    });
})

const setInputTerminal = (data) => {
    if(typeof data === 'object') {
        globalStore.buyAmount = globalStore.sellAmount = data.amount
        globalStore.buyPrice = globalStore.sellPrice = data.price
        globalStore.sellTotal = globalStore.buyTotal = data.total

        return
    }

    globalStore.buyPrice = globalStore.sellPrice = data
}

</script>
